import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Thumbs } from "swiper/modules";

import Spinner from "./Spinner.js";

import CopyUrlButton from "./CopyUrlButton";





import "swiper/css";
import "swiper/css/thumbs";

export default function ProductDetails() {
  const { slug } = useParams();

  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [mainSwiper, setMainSwiper] = useState(null);
  const [openIndex, setOpenIndex] = useState(null);
  

  // Fetch product by slug
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}products/${slug}`)
      .then((res) => {
        if (res.data.status) {
          setProduct(res.data.data);
          
          
        } else {
          setProduct(null);
          
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to load product", err);
        setLoading(false);
      });
  }, [slug]);

  if (loading) return <Spinner />;
  
  if (!product) return <div className="p-5">Product Not Found</div>;

  

  // Sort images: primary first
  const images = [...(product.images || [])].sort(
    (a, b) => b.is_primary - a.is_primary,
  );

  const accordionItems = [
    {
      title: "DETAILS & FIT",
      content: product.description,
    },
    {
      title: "FABRIC & CARE",
      content:product.fabric_description,
    },
  ];

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const productUrl = `${process.env.REACT_APP_SHARE_URL}product/${slug}`;


  return (
    <>
     <div className="container py-5">
      <div className="row g-4">
        {/* LEFT — DESKTOP THUMBNAILS */}
        <div className="col-lg-2 d-none d-lg-block">
          <Swiper
            direction="vertical"
            spaceBetween={10}
            slidesPerView={4}
            watchSlidesProgress
            onSwiper={setThumbsSwiper}
            style={{ height: "500px" }}
          >
            {images.map((img, index) => (
              <SwiperSlide key={img.id}>
                <img
                  src={img.image_url}
                  alt=""
                  className="img-fluid rounded"
                  style={{
                    cursor: "pointer",
                    height: "110px",
                    objectFit: "cover",
                  }}
                  onClick={() => mainSwiper && mainSwiper.slideTo(index)}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* CENTER — MAIN IMAGE */}
        <div className="col-lg-7 col-md-12 position-relative">
          {/* LEFT ARROW */}
          <button
            onClick={() => mainSwiper && mainSwiper.slidePrev()}
            style={navBtnStyle("left")}
          >
            ‹
          </button>

          {/* RIGHT ARROW */}
          <button
            onClick={() => mainSwiper && mainSwiper.slideNext()}
            style={navBtnStyle("right")}
          >
            ›
          </button>

          <Swiper
            spaceBetween={10}
            thumbs={{ swiper: thumbsSwiper }}
            modules={[Thumbs]}
            onSwiper={setMainSwiper}
          >
            {images.map((img) => (
              <SwiperSlide key={img.id}>
                <img
                  src={img.image_url}
                  alt={product.name}
                  className="img-fluid rounded"
                  style={{ width: "100%", objectFit: "cover" }}
                />
              </SwiperSlide>
            ))}
          </Swiper>

          {/* MOBILE THUMBNAILS */}
          <div className="d-lg-none mt-3">
            <Swiper slidesPerView={4} spaceBetween={10}>
              {images.map((img, index) => (
                <SwiperSlide key={img.id}>
                  <img
                    src={img.image_url}
                    className="img-fluid rounded"
                    style={{
                      cursor: "pointer",
                      height: "80px",
                      objectFit: "cover",
                    }}
                    onClick={() => mainSwiper && mainSwiper.slideTo(index)}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>

        {/* RIGHT — PRODUCT INFO */}
        <div className="col-lg-3 col-md-12">
          <h1 style={{ fontSize: "28px", fontWeight: 700 }}>{product.name}</h1>

          <h6 className="text-muted mb-3">Catalogue No # {product.catalogue_no}</h6>
        
           <h5
        style={{
          fontSize: "12px",
          lineHeight: "1.7",
          letterSpacing: "0.5em",
          fontFamily: "Figs, Raleway, sans-serif",
        }}
      >
        COLORS
      </h5>
          <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "8px",
        marginTop: "8px",
      }}
    >

          {product?.colors?.map((color) => (
        <div
          key={color.id}
          title={color.name}
          style={{
            width: "32px",
            height: "32px",
            borderRadius: "50%",
            background: color.code || "#ccc",
            fontWeight: 700,
            border: "2px solid rgb(221, 221, 221)",
            cursor: "pointer",
          }}
        />
      ))}

      </div>

      <h5
        style={{
          fontSize: "12px",
          lineHeight: "1.7",
          letterSpacing: "0.05em",
          fontWeight: 700,
          fontFamily: "Figs, Raleway, sans-serif",
        }}
      >
        SIZE 
      </h5>

      <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "8px",
        marginTop: "8px",
      }}
    >

      {product?.sizes?.map((size) => (
  <div
    key={size.id}
    title={size.label || size.name}
    style={{
      width: "38px",
      height: "38px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "12px",
      fontWeight: 600,
      cursor: "pointer",
      userSelect: "none",
      padding: "0 8px",
    }}
  >
    {size.name}
  </div>
))}

  <a href=""
        type="button"
        
        data-bs-toggle="modal"
        data-bs-target="#sizeChartModal"
      >
        Size Chart
      </a>


          {/* Bootstrap Modal */}
      <div
        className="modal fade"
        id="sizeChartModal"
        tabIndex="-1"
        aria-labelledby="sizeChartModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="sizeChartModalLabel">
                Size Chart
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body text-center">
              <img
                src="/size_chart.jpeg" 
                alt="Size Chart"
                className="img-fluid"
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
      

</div>

    <div
  className="line-clamp-2"
  style={{ fontSize: "13px", marginTop: "10px" }}
  dangerouslySetInnerHTML={{ __html: product.description }}
></div>

          {/* ACCORDION */}
          <div className="mt-4">
            {accordionItems.map((item, index) => (
              <div
                key={index}
                style={{
                  borderTop: "1px solid #e5e5e5",
                  padding: "16px 0",
                  cursor: "pointer",
                }}
              >
                <div
                  className="d-flex justify-content-between"
                  onClick={() => handleToggle(index)}
                >
                  <strong>{item.title}</strong>
                  <span>{openIndex === index ? "−" : "+"}</span>
                </div>

              {openIndex === index && (
  <div
    style={{ fontSize: "13px", marginTop: "10px" }}
    dangerouslySetInnerHTML={{ __html: item.content || "" }}
  />
)}
              </div>
            ))}
          </div>
          <div className="mt-2">
  <CopyUrlButton url={productUrl} />
</div>
        </div>
      </div>
      
    </div>
    </>
  );
}

/* NAV BUTTON STYLE */
function navBtnStyle(position) {
  return {
    position: "absolute",
    top: "50%",
    [position]: "40px",
    transform: "translateY(-50%)",
    background: "#fff",
    borderRadius: "50%",
    border: "1px solid #ddd",
    width: "44px",
    height: "44px",
    fontSize: "22px",
    fontWeight: "bold",
    zIndex: 10,
    cursor: "pointer",
  };
}
